import React, { useContext } from 'react';
import { Tabs } from 'antd';
import { AddYoutube } from '@src/components/side-bar-menu/stream/AddYoutube';
import { AddTwitch } from '@src/components/side-bar-menu/stream/AddTwitch';
import { AddIframe } from '@src/components/side-bar-menu/stream/AddIframe';
import styles from '../add-to-scene.module.css';
import { ThemeContext } from '../../../../pages/_app';
import * as THREE from 'three';

export default function LiveStreamsContent({ onAddToScene }) {
  const { isDark } = useContext(ThemeContext);

  const handleStreamAdd = (data) => {
    const streamWithScale = {
      ...data,
      scale: new THREE.Vector3(0.01, 0.01, 0.001),
    };

    onAddToScene(streamWithScale);
  };

  const commonProps = {
    selectedModel: null,
    callBack: handleStreamAdd,
    items: [{ name: 'stream' }],
  };

  const tabItems = [
    {
      key: 'youtube',
      label: 'YouTube',
      children: (
        <div className={styles.streamTab}>
          <AddYoutube {...commonProps} type='YOUTUBE' />
        </div>
      ),
    },
    {
      key: 'twitch',
      label: 'Twitch',
      children: (
        <div className={styles.streamTab}>
          <AddTwitch {...commonProps} />
        </div>
      ),
    },
    {
      key: 'iframe',
      label: 'Iframe',
      children: (
        <div className={styles.streamTab}>
          <AddIframe {...commonProps} />
        </div>
      ),
    },
  ];

  return (
    <div
      className={styles.streamContent}
      style={{ background: isDark ? '#141414' : '#fff' }}
    >
      <Tabs
        defaultActiveKey='youtube'
        centered
        className={isDark ? styles.darkTabs : ''}
        items={tabItems}
      />
    </div>
  );
}
